var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#36abff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.138 2.471a.667.667 0 1 0-.943-.942L6.862 2.862a.667.667 0 0 0 0 .943l1.333 1.333a.667.667 0 1 0 .943-.943l-.043-.042a4 4 0 0 1 1.27 7.073.667.667 0 1 0 .787 1.076 5.334 5.334 0 0 0-2.281-9.564l.267-.267ZM6.862 13.53l.266-.267a5.334 5.334 0 0 1-2.281-9.564.667.667 0 1 1 .788 1.076 4 4 0 0 0 1.269 7.073l-.042-.042a.667.667 0 1 1 .942-.943l1.334 1.333c.26.26.26.683 0 .943l-1.334 1.333a.667.667 0 1 1-.942-.942Z",
    clipRule: "evenodd"
  })));
};
export default SvgRetry;